<template>
  <div class="admin-container">
    <!-- 
      1, 用户管理
      2，概要管理
      3，图片管理
      
      这四个页面怎么切换：
      1，使用路由
      2，使用组件
      需要加菜单栏

      使用路由调转
    -->
    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="请输入名称" suffix-icon="el-icon-search"
        v-model="searchAbstract"></el-input>

      <el-button class="ml-5" type="primary" @click="loadSearch">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>


    <!-- 设置表格宽度为66% -->
    <el-table :data="tableData" stripe>
      <el-table-column prop="id" label="概要ID" sortable align="center">
      </el-table-column>
      <el-table-column prop="abstractTitle" label="文章名称" align="center">
      </el-table-column>
      <el-table-column prop="abstractContent" label="文章概要内容" align="center" width=200px show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="aboutAuthor" label="作者介绍" align="center" width=200px show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="abstractIsMag" label="是否提交到期刊" align="center">
        <template #default="{ row }">

          <el-tag v-if="row.abstractIsMag === 0" type="warning">否</el-tag>
          <el-tag v-if="row.abstractIsMag === 1" type="success">是</el-tag>

        </template>
      </el-table-column>


      <el-table-column prop="examineFlag" label="展示" align="center">

        <template #default="{ row }">

          <el-switch v-model="row.examineFlag" @change="changeStatus(row)" />

          <!-- <el-switch
                    v-model="scope.row.status1"
                    :active-value="0"
                    :inactive-value="1"
                    @change="changeStatus1(scope.row)"
                  >
                </el-switch> -->

          <!-- <el-tag v-if="row.examineFlag===" type="warning">
  <el-switch v-model="examineFlag" />
</el-tag>
<el-tag v-if="row.examineFlag===1" type="success">
  <el-switch v-model="examineFlag" />
</el-tag> -->

        </template>

      </el-table-column>

      <el-table-column prop="abstractAuthors" label="相关作者信息列表：" align="center">

        <template #default="{ row }">
          <el-link type="primary" @click="handleUserDetail(row)">点击查看</el-link>
        </template>

      </el-table-column>


      <el-table-column fixed="right" label="操作" width="280" align="center">
        <template #default="scope">
          <el-button @click="handleEdit(scope.row)" type="primary" size="small" class="edit-button"
            :icon="Edit">编辑</el-button>

                      <el-button @click="handleDown(scope.row.userFile)" type="primary" size="small" class="edit-button"
            :icon="Download">下载</el-button>

          <el-popconfirm title="确定删除吗？" @confirm="handleDel(scope.row.id)">
            <template #reference>
              <el-button size="small" type="danger" class="delete-button" :icon="Delete">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!--    引入分页组件-可以根据自己的需要进行定制-->
    <div style="margin: 10px 0">
      <el-pagination @size-change="handlePageSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[5, 10]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>



  </div>


  <el-dialog v-model="dialogVisible01" title="提交作者详情" width="500">
    <el-table :data="authorTableData" stripe>
      <el-table-column prop="authorName" label="作者" sortable align="center">
      </el-table-column>
      <el-table-column prop="authorUnit" label="单位" align="center">
      </el-table-column>
      <el-table-column prop="authorEmail" label="邮箱" align="center">
      </el-table-column>
    </el-table>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible01 = false">Cancel</el-button>
        <el-button type="primary" @click="dialogVisible01 = false">
          Confirm
        </el-button>
      </div>
    </template>


  </el-dialog>


  <el-dialog title="编辑用户信息" v-model="dialogVisible" width="40%">

    <el-form :model="form" :inline="true" style="max-width: 700px;min-width: 400px;" ref="userForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="文章标题名称：" prop="abstractTitle" :rules="[{ required: true, message: '文章标题必须填写' }]">
            <el-input v-model="form.abstractTitle" style="width: 400px;" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="文章内容概要：" prop="abstractContent" :rules="[{ required: true, message: '概要' }]">
            <el-input v-model="form.abstractContent" type="textarea" style="width: 400px;" rows="5" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="作者介绍：" prop="aboutAuthor" :rules="[{ required: true, message: '作者介绍' }]">
            <el-input v-model="form.aboutAuthor" type="textarea" style="width: 400px;" rows="5" />
          </el-form-item>
        </el-col>
      </el-row>


      <el-row>
        <el-col> <el-form-item label="是否愿意走期刊快速发表通道：" prop="abstractIsMag"
            :rules="[{ required: true, message: '是否愿意走期刊快速发表通道' }]">
            <el-radio-group v-model="form.abstractIsMag">
              <el-radio value="1">是</el-radio>
              <el-radio value="0">否</el-radio>
            </el-radio-group>
          </el-form-item></el-col>
      </el-row>
      <el-row>

        <el-col :span="7">
          <el-form-item label="作者" v-for="(domain, index) in form.authorList" :key="domain" :label="'domain' + index"
            :prop="'authorList.' + index + '.authorName'" :rules="[{ required: true, message: '作者不能为空' }]">

            <el-input v-model="domain.authorName" style="width: 140px;" />
          </el-form-item>
        </el-col>

        <el-col :span="7"> <el-form-item label="单位" v-for="(domain, index) in form.authorList" :key="domain"
            :label="'domain' + index" :prop="'authorList.' + index + '.authorUnit'"
            :rules="[{ required: true, message: '单位不能为空' }]">
            <el-input v-model="domain.authorUnit" style="width: 140px;" />
          </el-form-item></el-col>

        <el-col :span="7"> <el-form-item label="邮箱" v-for="(domain, index) in form.authorList" :key="domain"
            :label="'domain' + index" :prop="'authorList.' + index + '.authorEmail'"
            :rules="[{ required: true, message: '邮箱不能为空' }]">
            <el-input v-model="domain.authorEmail" style="width: 140px;" />
          </el-form-item></el-col>

        <el-col :span="3">

          <el-form-item label="" v-for="(domain, index) in form.authorList" :key="domain" :label="'domain' + index"
            :prop="'authorList.' + index + '.value'">
            <el-button plain :icon="Delete" @click="deleteAuthor(index)">删除</el-button>

          </el-form-item>
        </el-col>

      </el-row>


      <el-row>

        <el-col :span="7">
          <el-form-item>
            <el-button plain :icon="Plus" @click="addAuthor">新增</el-button>

          </el-form-item>
        </el-col>
      </el-row>



      <el-form-item>
        <el-button type="primary" @click="submitAbstract">提交</el-button>
        <el-button type="primary" @click="resetAbstract">关闭</el-button>

      </el-form-item>
    </el-form>

  </el-dialog>

</template>

<script>
import request from "@/utils/request";
import { Delete, Edit, Plus,Download } from '@element-plus/icons-vue'
import {
  ref,
  reactive,
  getCurrentInstance,
  onMounted,
} from 'vue'

import axios from 'axios';

import { ElMessage } from 'element-plus'


export default {

  setup() {

    // currentPage: 1,
    //   pageSize: 5,
    //   total: 10,
    //   tableData: [],
    //   dialogVisible: false,
    const dialogVisible01 = ref(false);


    const { proxy } = getCurrentInstance();

    const currentPage = ref(1);
    const pageSize = ref(5);
    const total = ref(10);
    const tableData = ref([]);
    const dialogVisible = ref(false);

    const searchAbstract = ref();

    const form = reactive({
      id: '',
      abstractTitle: '',
      abstractContent: '',
      aboutAuthor: '',
      abstractIsMag: '',
      authorList: [
        {
          authorName: '',
          authorUnit: '',
          authorEmail: '',
        }
      ],
    });


    const authorTableData = ref([]);


    onMounted(() => {

      list();
    });

    const handleDown = (lunPdf) => {
            const a = document.createElement('a')
      a.href = lunPdf
      a.download = 'lunPdf.pdf'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }


    const handlePageSizeChange = (pageSize2) => {

      pageSize.value = pageSize2
      list()
    };
    const handleCurrentChange = (pageNum) => {
      currentPage.value = pageNum
      list()
    };
    //查询所有信息
    const list = () => {
      request.get(`/api/abstract/searchAllUserAbstract?pageNum=${currentPage.value}&pageSize=${pageSize.value}&abstractTitle=${searchAbstract.value}`)
        .then(res => {
          console.log("res11", res);

          tableData.value = res.data.records;
          console.log("res22", tableData);

          total.value = res.data.total;
        })
        .catch(error => {
          console.log("Request failed", error);
        });
    };
    //保存编辑对象
    const save = () => {
      request.post("/api/update", {
        id: form.id,
        username: form.username,
        realName: form.realName,
        password: form.password,
        phone: form.phone,
        email: form.email,
        workUnit: form.workUnit
      }).then(
        res => {
          if (res.code === "200") {

            ElMessage({
              showClose: true,
              message: res.msg,
              type: "success",
            });
          } else {

            ElMessage({
              showClose: true,
              message: res.msg,
              type: "error",
            });
          }
          console.log("res", res)
          dialogVisible.value = false
          list()
        }
      )


    };
    const handleEdit = (row) => {
      // 编辑逻辑
      //直通通过row获取当前行信息
      dialogVisible.value = true
      proxy.$nextTick(() => { //解决新增有编辑的数据问题
        // 浅拷贝，将row拷贝到formUser
        Object.assign(form, row);
        form.abstractIsMag = row.abstractIsMag === null ? "0" : row.abstractIsMag.toString();
      });
    };
    const handleDel = (id) => {
      console.log('Deleting ID:', id);
      // 删除逻辑
      request.delete(`/api/abstract/deletehUserAbstract?abstracId=${id}`).then(
        res => {
          if (res.code === "200") {

            ElMessage({
              showClose: true,
              message: '删除成功',
              type: "success",
            });
          } else {

            ElMessage({
              showClose: true,
              message: res.msg,
              type: "error",
            });
          }
          console.log("res", res)
          list()
        }
      )
    };


    const handleUserDetail = (row) => {
      console.log('User ID:', row);
      dialogVisible01.value = true;
      authorTableData.value = row.authorList;
    };

    const submitAbstract = () => {
      proxy.$refs.userForm.validate(async (valid) => {
        if (valid) {
          const response = await axios.post("/api/abstract/updateUserAbstract", form);
          let res = response.data; // 假设返回的用户信息在 response.data 中
          console.log("请求: ", res);
          if (res.code === "200") {//登陆成功
            ElMessage({
              showClose: true,
              message: '修改成功',
              type: "success",
            });

            list();

            dialogVisible.value = false;
          } else {
            ElMessage({
              showClose: true,
              message: user.msg,
              type: "warning",
            });
          }


        } else {
          ElMessage({
            showClose: true,
            message: "请输入正确的内容",
            type: "error",
          })
        }
      })
    };

    const resetAbstract = () => {
      dialogVisible.value = false;
    };

    //新增作者
    const addAuthor = () => {
      form.authorList.push({
        username: '',
        workUnit: ''
      });
    };

    //删除作者
    const deleteAuthor = (index) => {

      console.log("bug", form.authorList)

      console.log("bu2", index)

      //有待确定，有bug
      if (form.authorList.length > 1) {
        form.authorList.splice(index, 1);
      } else {
        ElMessage({
          showClose: true,
          message: '至少要保留一条信息',
          type: 'warning',
        })
      }
    };

    const loadSearch = () => {
      request.get("/api/abstract/searchUserAbstract", {
        params: {
          abstractTitle: searchAbstract.value,
          pageNum: currentPage.value,
          pageSize: pageSize.value,
        }
      }).then(res => {
        console.log("res11", res);

        tableData.value = res.data.records;
        console.log("res22", tableData);

        total.value = res.data.total;
      })
    };
    const reset = () => {
      searchAbstract.value = "";
      list()
    };

    const changeStatus = (row) => {
      //alert(row)
      request.get("/api/abstract/examineAbstract", {
        params: {
          id: row.id,
          examineFlag: row.examineFlag,
        }
      }).then(res => {
        if (res.code === "200") {

          ElMessage({
            showClose: true,
            message: '审查成功',
            type: "success",
          });
        } else {

          ElMessage({
            showClose: true,
            message: '审核失败',
            type: "error",
          });
        }
        list();
      })

    };


    return {
      tableData,
      form,
      dialogVisible,
      total,
      pageSize,
      currentPage,
      list,
      handleEdit,
      handleDel,
      save,
      loadSearch,
      reset,
      handlePageSizeChange,
      handleCurrentChange,
      handleUserDetail,
      dialogVisible01,
      authorTableData,
      submitAbstract,
      resetAbstract,
      addAuthor,
      deleteAuthor,
      Delete, Edit, Plus,Download,
      changeStatus,
      searchAbstract,
      handleDown
    }
  }
}



</script>

<style>
.admin-container {
  margin: auto;
  width: 80%;
}

.edit-button {
  color: #409eff;
  /* 蓝色 */
}

.delete-button {
  color: #f56c6c;
  /* 红色 */
}

.action-button {
  margin: 0 5px;
  /* 按钮之间的间距 */
}
</style>
